import * as React from "react";
import { Tab, TabList } from "@fluentui/react-components";
import { Group } from "../../types/models";
import { useIconPickerStyles } from "./iconPickerStyles";

interface Props {
  activeGroup: string;
  groups: Group[];
  onSelectGroup: (group: string) => void;
}

const IconPickerTabs: React.FC<Props> = ({ activeGroup, groups, onSelectGroup }) => {
  const styles = useIconPickerStyles();

  return (
    <TabList
      className={styles.tabsContainer}
      selectedValue={activeGroup}
      onTabSelect={(_, data) => onSelectGroup(String(data.value))}
    >
      {groups.map((group) => (
        <Tab key={group.group} value={group.group}>
          {group.group}
        </Tab>
      ))}
    </TabList>
  );
};

export default IconPickerTabs;
